"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderContactInformationContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "The only required contact type is the Public Contact, which will show in the Public Work Search. Only first name and email are required."),
    react_1.default.createElement("p", null,
        "For full information about public database contact types, click\u00A0",
        react_1.default.createElement("a", { target: '_blank', rel: 'noreferrer', href: 'https://help.themlc.com/en/support/contact-types' }, "here."))));
exports.default = RightsholderContactInformationContentHeader;
